/* eslint-disable
    import/order
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
import Backbone from 'backbone';
import $ from 'jquery';

import ifCreateFromHash from 'util/ifCreateFromHash';
import {openCRISPRModal} from './CRISPRModal';
import SidebarActions from 'sidebar/SidebarActions';

class CreateCRISPRLink extends Backbone.View {
  render() {
    $(document).on('click', '.js-create-new-crispr', (e) => {
      e.preventDefault();
      openCRISPRModal();
    });

    ifCreateFromHash('#create/crispr', () => {
      openCRISPRModal();
      SidebarActions.close();
    });
    return this;
  }
}

export default CreateCRISPRLink;
